import { formatDuration as sharedFormatDuration } from "@/lib/analytics/format";

/**
 * Pure helpers of the response-time section.
 *
 * Their own module because they are worth testing on their own, and importing
 * them from the component drags its whole graph — which now reaches a server
 * action, and through it a Supabase client built at module scope.
 */

/** «Pending» is this dashboard's word for a reply that has not happened yet. */
export function formatDuration(ms: number | null): string {
  return sharedFormatDuration(ms, "Pending");
}

export function median(values: number[]): number {
  if (values.length === 0) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 !== 0
    ? sorted[mid]
    : (sorted[mid - 1] + sorted[mid]) / 2;
}

export function percentile(values: number[], p: number): number {
  if (values.length === 0) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const idx = Math.ceil((p / 100) * sorted.length) - 1;
  return sorted[Math.max(0, idx)];
}
